import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@material-tailwind/react";
import { DocumentArrowDownIcon } from "@heroicons/react/24/solid";
import SafetyDiagExportModal from "./SafetyDiagExportModal";

/**
 * Trigger button opening the safety diagnosis report export modal (PDF).
 */
export default function SafetyDiagExportButton({
  workOrderId,
  realizationId,
  attemptLabel,
  workOrderRef,
  languageIsoCode,
  customerLanguages,
  customer,
}: {
  workOrderId: string;
  realizationId?: string;
  attemptLabel?: string;
  workOrderRef?: string;
  languageIsoCode?: string;
  customerLanguages?: any[];
  customer?: EasyTech.Customer;
}) {
  const { t } = useTranslation("diagSecu");
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        variant="filled"
        size="md"
        className="flex items-center gap-2 bg-blue-500 text-white shadow-md text-sm px-3 rounded-lg font-thin normal-case hover:bg-blue-600"
        onClick={() => setShowModal(true)}
      >
        <DocumentArrowDownIcon className="h-4 w-4 text-white" />
        {t("diagSecu:report:export:download")}
      </Button>

      <SafetyDiagExportModal
        open={showModal}
        onClose={() => setShowModal(false)}
        workOrderId={workOrderId}
        workOrderRef={workOrderRef}
        realizationId={realizationId}
        attemptLabel={attemptLabel}
        languageIsoCode={languageIsoCode}
        customerLanguages={customerLanguages}
        customer={customer}
      />
    </>
  );
}
